import { url } from 'url';

const { apiClient } = require('service');

export const fetchService = async () => {
  const response = await apiClient.get(url);
  return response.data;
};

export const fetchAdsl = async () => {
  const response = await apiClient.get(url.fetchDetail(2));
  return response.data;
};
export const fetchFourG = async () => {
  const response = await apiClient.get(url.fetchDetail(1));
  return response.data;
};

export const fetchOwa = async () => {
  const response = await apiClient.get(url.fetchDetail(4));
  return response.data;
};
export const fetchTell = async () => {
  const response = await apiClient.get(url.fetchDetail(5));
  return response.data;
};

export const fetchFiber = async () => {
  const response = await apiClient.get(url.fetchDetail(6));
  return response.data;
};

export const fetchTdLte = async () => {
  const response = await apiClient.get(url.fetchDetail(3));
  return response.data;
};

export const contactUs = async (data) => {
  const response = await apiClient.post(url.submitContactUs(data));
  return response.data;
};
